import makeStyles from '@mui/styles/makeStyles';

export const rowStyles = makeStyles((theme) => ({
  row: {
    fontSize: 13,
  },
  listRow: {
    cursor: 'pointer',
  },
  flexRow: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  rowBg: {
    backgroundColor: theme.palette.action.disabledBackground,
  },
  headerRow: {
    borderBottom: `1px solid ${theme.colors.darkGrey}`,
  },
  name: {
    width: '36%',
    display: 'flex',
    paddingRight: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  item33: {
    width: '33%',
  },
  item50: {
    width: '50%',
  },
  access: {
    width: '36%',
    display: 'flex',
    paddingRight: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  status: {
    width: '18%',
    display: 'flex',
    paddingRight: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  checkbox: {
    width: '36px',
  },
  accessIcon: {
    marginRight: 5,
  },
  itemSm: {
    width: '40%',
    marginRight: theme.spacing(1),
    overflow: 'hidden',
    paddingBottom: theme.spacing(0.5),
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  itemMd: {
    width: '50%',
    marginRight: theme.spacing(1),
    overflow: 'hidden',
    paddingBottom: theme.spacing(0.5),
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  itemLg: {
    width: '60%',
    marginRight: theme.spacing(1),
    overflow: 'hidden',
    paddingBottom: theme.spacing(0.5),
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  xsHide: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
}));

export default makeStyles((theme) => ({
  selectedContainer: {},
  selectedText: {
    fontSize: 13,
    fontWeight: 'bold',
    fontStyle: 'italic',
    padding: theme.spacing(2),
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: theme.spacing(1),

    '& button': {
      backgroundColor: theme.colors.blue,
      marginRight: theme.spacing(1),
      color: theme.colors.white,

      '&:first-child': {
        backgroundColor: theme.colors.black,
      },

      '&.accessButton': {
        backgroundColor: theme.colors.blue,
      },
    },
  },

  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 auto',

    '& .MuiInputBase-root': {
      width: '100%',
    },
    '& .MuiFormGroup-root': {
      backgroundColor: theme.palette.action.disabled,
      width: '85%',
      marginTop: theme.spacing(3),
      padding: `0 ${theme.spacing(1)}`,
    },
  },

  modalContent: {
    padding: theme.spacing(4),
  },
  modalTitle: {
    fontWeight: 'bold',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  nameRow: {
    margin: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  centerLoader: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },

  barTitle: {
    textAlign: 'center',
    width: '100%',
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  profileContainer: {
    position: 'relative',
    top: 64,
  },
  xsHide: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));
